function convertDecimalToHexColor(decimal: number): string {
  const hex = decimal.toString(16);
  return `#${hex.padStart(6, '0')}`;
}

export default convertDecimalToHexColor;
